"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const native_request_1 = require("./native_request");
const jsonparser_1 = require("./jsonparser");
const errors_1 = require("../errors");
/**
 * The currenly used api url
 * @type {string}
 */
let apiURL = 'https://api.bpmsupreme.com';
if (typeof global !== 'undefined') {
    if (typeof global.Environment !== 'undefined' && typeof global.Environment.API === 'string') {
        apiURL = global.Environment.API;
    }
}
/**
 * The currenly used user agent
 * @type {string}
 */
let userAgent = 'bpmmobile';
/**
 * The global handler for unauthorized handlers
 */
let unauthorizedHandler = undefined;
let userUpdatedHandler = undefined;
let userNotVerifiedHandler = undefined;
/**
 * The global remix options
 */
let remixOptions;
/**
 * The global handler for subscription errors
 */
let invalidSubscriptionHandler = undefined;
/**
 * This encapsulates the current session information
 */
class Session {
    /**
     * This sets the global remix options
     */
    static setRemixOptions(options) {
        remixOptions = options;
    }
    /**
     * This returns the global remix options
     */
    static getRemixOptions() {
        return remixOptions;
    }
    /**
     * This sets the global unauthorized handler
     */
    static setUnauthorizedHandler(handler) {
        unauthorizedHandler = handler;
    }
    /**
     * This returns the global unauthorized handler
     */
    static getUnauthorizedHandler() {
        return unauthorizedHandler;
    }
    static setUserUpdatedHandler(handler) {
        userUpdatedHandler = handler;
    }
    static getUserUpdatedHandler() {
        return userUpdatedHandler || ((user) => { });
    }
    static setUserNotVerifiedHandler(handler) {
        userNotVerifiedHandler = handler;
    }
    static getUserNotVerifiedHandler() {
        return userNotVerifiedHandler || (() => { });
    }
    /**
     * This sets the global subscription error handler
     */
    static setSubscriptionHandler(handler) {
        invalidSubscriptionHandler = handler;
    }
    /**
     * This returns the subscription error handler
     */
    static getSubscriptionHandler() {
        return invalidSubscriptionHandler;
    }
    /**
     * This sets the api url to use
     * @param {string} url
     */
    static setAPIURL(url) {
        apiURL = url;
    }
    /**
     * This returns the currently used api url
     * @returns {string}
     */
    static getAPIURL() {
        return apiURL;
    }
    /**
     * This sets the user agent to use
     * @param {string} url
     */
    static setUserAgent(agent) {
        userAgent = agent;
    }
    /**
     * This returns the currently used user agent
     * @returns {string}
     */
    static getUserAgent() {
        return userAgent;
    }
    /**
     * This retreives the current session data
     * @returns {string | undefined}
     */
    static getSession() {
        return this.cachedSession ? this.cachedSession.session_token : undefined;
    }
    /**
     * This sets the current session data
     * @param {any | string | undefined} session
     */
    static setSession(session) {
        this.cachedSession = typeof session === 'object' ? session : { 'session_token': session };
    }
}
exports.Session = Session;
var HTTPMethod;
(function (HTTPMethod) {
    HTTPMethod["GET"] = "GET";
    HTTPMethod["PUT"] = "PUT";
    HTTPMethod["DELETE"] = "DELETE";
    HTTPMethod["POST"] = "POST";
})(HTTPMethod = exports.HTTPMethod || (exports.HTTPMethod = {}));
var APIVersion;
(function (APIVersion) {
    APIVersion["v1_0"] = "v1";
    APIVersion["v1_1"] = "v1.1";
    APIVersion["v1_2"] = "v1.2";
    APIVersion["adminV1"] = "admin/v1";
    APIVersion["v2_0"] = "v2.0";
    APIVersion["v3_0"] = "v3.0";
})(APIVersion = exports.APIVersion || (exports.APIVersion = {}));
class BasicRequest {
    constructor(path, method, apiVersion = APIVersion.v1_1, queryParameters, bodyParameters) {
        this.preventInvalidSubscriptionHandler = false;
        this.preventNotVerifiedHandler = false;
        this.path = path;
        this.method = method;
        this.apiVersion = apiVersion;
        this.queryParameters = Object.assign({ remix: remixOptions }, queryParameters);
        this.bodyParameters = bodyParameters;
    }
    serialize() {
        let apiRequest = {
            url: (this.overrideAPIUrl || apiURL) + '/' + this.apiVersion + this.path,
            json: true,
            method: this.method,
            headers: {},
            user_agent: userAgent,
            signal: this.abortSignal
        };
        if (this.refresh_token) {
            apiRequest.headers = Object.assign({}, apiRequest.headers, { 'Authorization': 'Bearer ' + this.refresh_token });
        }
        if (this.queryParameters) {
            apiRequest.qs = this.queryParameters;
        }
        if (this.bodyParameters) {
            apiRequest.body = this.bodyParameters;
        }
        return apiRequest;
    }
    send(returnType) {
        let promise = new Promise((resolve, reject) => {
            native_request_1.request(this.serialize(), (error, response, body) => {
                if (error) {
                    reject(error);
                }
                else if (response && response.status >= 200 && response.status <= 299) {
                    if (body && body.data) {
                        if (!returnType) {
                            return resolve({
                                data: body.data,
                                pagination: body.pagination,
                                originalResponse: response
                            });
                        }
                        if (Array.isArray(body.data)) {
                            resolve({
                                data: body.data.map((body) => {
                                    try {
                                        return this.parseReponse(returnType, body);
                                    }
                                    catch (error) {
                                        console.log(error);
                                        return undefined;
                                    }
                                }).filter(Boolean),
                                pagination: body.pagination,
                                originalResponse: response
                            });
                        }
                        else {
                            try {
                                resolve({
                                    data: this.parseReponse(returnType, body.data),
                                    pagination: body.pagination,
                                    originalResponse: response
                                });
                            }
                            catch (error) {
                                reject({
                                    type: errors_1.APIErrorType.UnknownError,
                                    status: 500,
                                    underlyingError: error,
                                    message: error.message || 'The response could not be parsed'
                                });
                            }
                        }
                    }
                    else if (body && body.error) {
                        if ([errors_1.APIErrorType.SessionNotFoundError, errors_1.APIErrorType.MissingAuthorizationError].includes(body.error.type) && unauthorizedHandler) {
                            try {
                                unauthorizedHandler(body.error);
                            }
                            catch (e) {
                                console.log('unauthorizedHandler threw: ' + e.toString());
                            }
                        }
                        else if (!this.preventInvalidSubscriptionHandler && [errors_1.APIErrorType.InvalidSubscriptionError].includes(body.error.type) && invalidSubscriptionHandler) {
                            try {
                                invalidSubscriptionHandler(body.error);
                            }
                            catch (e) {
                                console.log('invalidsubscriptionhandler threw: ' + e.toString());
                            }
                        }
                        else if (!this.preventNotVerifiedHandler && [errors_1.APIErrorType.NotVerifiedError].includes(body.error.type)) {
                            try {
                                userNotVerifiedHandler && userNotVerifiedHandler(body.error);
                            }
                            catch (e) {
                                console.log('invalidsubscriptionhandler threw: ' + e.toString());
                            }
                        }
                        reject(body.error);
                    }
                    else {
                        reject({
                            type: errors_1.APIErrorType.UnknownError,
                            status: 500,
                            message: 'The response could not be parsed'
                        });
                    }
                }
                else {
                    if (body && body.error) {
                        if ([errors_1.APIErrorType.SessionNotFoundError, errors_1.APIErrorType.MissingAuthorizationError].includes(body.error.type) && unauthorizedHandler) {
                            try {
                                unauthorizedHandler(body.error);
                            }
                            catch (e) {
                                console.log('unauthorizedHandler threw: ' + e.toString());
                            }
                        }
                        else if (!this.preventInvalidSubscriptionHandler && [errors_1.APIErrorType.InvalidSubscriptionError].includes(body.error.type) && invalidSubscriptionHandler) {
                            try {
                                invalidSubscriptionHandler(body.error);
                            }
                            catch (e) {
                                console.log('invalidsubscriptionhandler threw: ' + e.toString());
                            }
                        }
                        else if (!this.preventNotVerifiedHandler && [errors_1.APIErrorType.NotVerifiedError].includes(body.error.type)) {
                            try {
                                userNotVerifiedHandler && userNotVerifiedHandler(body.error);
                            }
                            catch (e) {
                                console.log('invalidsubscriptionhandler threw: ' + e.toString());
                            }
                        }
                        reject(body.error);
                    }
                    else {
                        reject({
                            type: errors_1.APIErrorType.UnknownError,
                            status: 500,
                            message: 'The response could not be parsed'
                        });
                    }
                }
            });
        });
        return promise.catch((error) => {
            if (error.type && error.message && error.status) {
                throw error;
            }
            else {
                const error = new Error('message');
                error.type = errors_1.APIErrorType.NetworkError;
                error.status = 999;
                error.message = 'An unknown error occurred / ' + this.path + ' / ' + this.method;
                error.underlying = error;
                throw error;
            }
        });
    }
    parseReponse(clazz, response) {
        return jsonparser_1.default.deserialize(clazz, response);
    }
}
exports.BasicRequest = BasicRequest;
class AuthenticatedRequest extends BasicRequest {
    constructor(path, method, apiVersion = APIVersion.v1_0, queryParameters, bodyParameters) {
        super(path, method, apiVersion, queryParameters, bodyParameters);
        this.authToken = Session.getSession();
    }
    serialize() {
        let options = super.serialize();
        if (this.authToken && !this.refresh_token) {
            options.headers = Object.assign({}, options.headers, { 'Authorization': 'Bearer ' + this.authToken });
        }
        return options;
    }
}
exports.AuthenticatedRequest = AuthenticatedRequest;
class AuthenticatedFileRequest extends AuthenticatedRequest {
    constructor(path, method, apiVersion = APIVersion.v1_0, queryParameters, bodyParameters) {
        if (bodyParameters) {
            let body = new FormData();
            let data = bodyParameters;
            for (let key of Object.keys(data)) {
                body.append(key, data[key], 'image');
            }
            bodyParameters = body;
        }
        super(path, method, apiVersion, queryParameters, bodyParameters);
    }
    serialize() {
        let options = super.serialize();
        options.json = false;
        return options;
    }
}
exports.AuthenticatedFileRequest = AuthenticatedFileRequest;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/requests/request.js
// module id = 46
// module chunks = 0